<script>
  import titreDefault from './titre-default.vue'
  import bookDrawer from './book-drawer.vue'
  export default {
    name: 'Titre',
    extends: titreDefault,
    components: {
      bookDrawer,
    },
  }
</script>

<template lang="pug">

book-drawer(v-if="titre", :id="titre.livres && titre.livres[0].id")
  template(scope="{ livre }")
    slot(:titre="titre", :livre="livre")
</template>

<style lang="postcss" scoped>



  .book-default {


  }
</style>



// WEBPACK FOOTER //
// titre-drawer.vue?18d20cbe